import React from "react";
import { Skeleton } from "@mui/material";
import { MuiBox } from "components/atoms";

const UserProfileSkeleton = ({ rowCount = 2 }) => {
  return (
    <MuiBox
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      {Array.from({ length: rowCount }).map((_, index) => (
        <MuiBox
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <MuiBox
            sx={{
              display: "flex",
              gap: { xs: "8px", md: "12px" },
              alignItems: "center",
              width: "100%",
            }}
          >
            {/* Avatar */}
            <Skeleton
              variant="circular"
              width={36}
              height={36}
              sx={{
                flexShrink: 0,
                "@media (max-width:600px)": {
                  width: 32,
                  height: 32,
                },
              }}
            />

            {/* Name + email + remove */}
            <MuiBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1,
                minWidth: 0,
                gap: "8px",
              }}
            >
              <MuiBox
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  minWidth: 0,
                  gap: "4px",
                }}
              >
                <Skeleton
                  variant="text"
                  width="55%"
                  height={18}
                  sx={{ maxWidth: 180 }}
                />

                <Skeleton
                  variant="text"
                  width="75%"
                  height={18}
                  sx={{ maxWidth: 220 }}
                />
              </MuiBox>

              <Skeleton
                variant="text"
                width={48}
                height={20}
                sx={{
                  flexShrink: 0,
                }}
              />
            </MuiBox>
          </MuiBox>

          {index !== rowCount - 1 && <Skeleton variant="text" width="100%" height={1} />}
        </MuiBox>
      ))}
    </MuiBox>
  );
};

export default UserProfileSkeleton;
